<div class="body-container">
    <div class="header-body">
        <app-header></app-header>
        <router-outlet></router-outlet>
    </div>
    <div class="push-footer">
        <app-footer></app-footer>
    </div>
</div>
<!-- ajouter target_blank -->

<div class="lien-mobile-reservation" [ngClass]="{'lien-mobile-reservation-closed':isCLosed}">
    <a href="https://heat-training-sport.web.app/reservation" class="text-decoration-none">
        <div class="text m-0" [ngClass]="{'text-closed':isCLosed}">Réservez votre séance</div>
    </a>
    <button type="button" class="btn-close" 
        [ngClass]="{'text-closed':isCLosed}" 
        (click)="onClose()">
    </button>
</div>
